import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UserAuth {
  id: string;
  role: string;
  userName: string;
  name: string;
  status: string;
  avatar?: string;
}

interface AuthStore {
  user: UserAuth | undefined;
  setUser: (user: UserAuth) => void;
  getUser: () => UserAuth | undefined;
  clearUser: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set, get) => ({
      user: undefined,

      setUser: (user: UserAuth) => {
        set({ user });
      },

      getUser: () => {
        return get().user;
      },

      clearUser: () => {
        set({ user: undefined });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ user: state.user }),
    }
  )
);
